import { FC } from 'react';
import { Box, Svg, Text } from '@hopskipdrive/react-components';

import { SuggestionChip, TitleContainer } from './Suggestion.styles';

interface SuggestionProps {
  title: string;
  anchorTime?: string;
  riderCount: number;
  durationInMinutes: number;
  riders?: string[];
  disabled?: boolean;
  onClick: () => void;
}

export const Suggestion: FC<SuggestionProps> = ({
  title,
  anchorTime,
  durationInMinutes,
  riders,
  riderCount,
  disabled,
  onClick,
}) => {
  return (
    <Box
      data-testid="smartpooling-suggestion"
      display="flex"
      flexDirection="column"
      gap="4px"
      {...(!disabled && { onClick: onClick })}
      style={{ cursor: !disabled ? 'pointer' : 'default' }}
    >
      <TitleContainer>
        <Text variant="labelL" fontWeight={500} textColor="secondary-hover">
          {title}
        </Text>
        {anchorTime && (
          <Text variant="labelXS" fontWeight={500} textColor="text-light">
            {anchorTime}
          </Text>
        )}
        {durationInMinutes > 0 && (
          <Text
            ml="auto"
            mr="12px"
            variant="labelS"
            fontWeight={500}
            textColor="secondary"
          >{`Current ride duration: ${durationInMinutes}min`}</Text>
        )}
      </TitleContainer>

      <Box display="flex" gap="0.5rem" flexWrap="wrap">
        <SuggestionChip
          size="small"
          label={
            <>
              <Svg height="30px" icon="person-filled" />
              <Text variant="labelS" fontWeight={500} textColor="secondary">
                {riderCount || '-'}
              </Text>
            </>
          }
        />
        {riders?.map((riderName) => (
          <SuggestionChip key={riderName} label={riderName} />
        ))}
      </Box>
    </Box>
  );
};
